import { FC } from 'react'
import { useGetReceiptPositionsQuery } from '../../../../../../../store/api/receipt-positions-api'
import Text from 'antd/es/typography/Text'
import { MaterialRequirementsConfiguration } from '../../../../../../../types/api/components/material/material-requirements-configuration'
import MaterialType from '../../../../../../../types/api/material-type'
import renderDatetime from '../../../../../../../helpers/tables/render-datetime'

interface ReceiptProps {
    config: MaterialRequirementsConfiguration
    materialType: MaterialType
    shipmentDocId: string
    /** При нескольких заявках на один материал позиции различаются по связи с заявкой */
    orderRequestDocumentId?: string
}

const Receipt: FC<ReceiptProps> = ({
    shipmentDocId,
    materialType,
    config,
    orderRequestDocumentId,
}) => {
    const getReceiptPositionsState = useGetReceiptPositionsQuery(
        {
            filters: {
                shipment: { documentId: { $eq: shipmentDocId } },
                material: { documentId: { $eq: config.material?.documentId } },
                ...(orderRequestDocumentId
                    ? { order_request: { documentId: { $eq: orderRequestDocumentId } } }
                    : {}),
            },
            populate: {
                shipment: true,
                receipt: true,
            },
        },
        { refetchOnMountOrArgChange: true }
    )

    const positions = getReceiptPositionsState?.data?.data || []

    if (positions.length === 0) return <Text type={'danger'}>Ошибка, заказ не найден</Text>
    if (positions.length > 1) return <Text type={'danger'}>Ошибка, несколько заказов</Text>

    const position = positions[0]
    const width = <Text strong>{config.material?.width}</Text>
    const unitShortName = materialType?.unit?.shortName
    const amountWithUnit = unitShortName
        ? `${position.amount} ${unitShortName}`
        : `${position.amount}`
    if (position.positionStatus === 'Принята') {
        return (
            <Text>
                {width} {amountWithUnit} принято
            </Text>
        )
    }

    // TODO: когда заказ завершен, нужно чекать его фактическую резервацию
    switch (position.receipt?.receiptStatus) {
        case 'Создан':
            return (
                <Text>
                    {width} заказано {amountWithUnit}, ожидается{' '}
                    {renderDatetime(position.receipt?.estimatedDate || '').slice(0, 10)}
                </Text>
            )
        case 'Отменен':
            return (
                <Text type={'danger'}>
                    {width} {amountWithUnit} {position.receipt.receiptStatus.toLocaleLowerCase()}
                </Text>
            )
        default:
            return (
                <Text>
                    {width} {amountWithUnit} заказ{' '}
                    {position.receipt?.receiptStatus.toLocaleLowerCase()}
                </Text>
            )
    }
}

export default Receipt
